export default __webpack_public_path__ + "static/media/KOD0131-min.bf75aab1.webp";